/**
 * Constantes / helpers de actividad semanal de líderes (cliente).
 */

export const WEEKLY_MIN_DRIVERS = 2;
export const WEEKLY_MIN_CUSTOMERS = 2;

export const LEADER_ALERT_STATUS = {
  PENDING: 'pendiente',
  REVIEWED: 'revisada',
  MANAGED: 'gestionada',
};

export const LEADER_ALERT_STATUS_LABELS = {
  pendiente: 'Pendiente',
  revisada: 'Revisada',
  gestionada: 'Gestionada',
};

function bogotaParts(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Bogota',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    weekday: 'short',
  }).formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type)?.value;
  return {
    year: Number(get('year')),
    month: Number(get('month')),
    day: Number(get('day')),
    weekday: get('weekday'),
  };
}

/** Clave de semana = lunes YYYY-MM-DD (Bogotá). */
export function getWeekKey(date = new Date()) {
  const { year, month, day, weekday } = bogotaParts(date);
  const utcNoon = Date.UTC(year, month - 1, day, 12);
  const dayIdx = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[
    weekday
  ];
  const sinceMonday = (dayIdx + 6) % 7;
  const monday = new Date(utcNoon - sinceMonday * 86400000);
  const y = monday.getUTCFullYear();
  const m = String(monday.getUTCMonth() + 1).padStart(2, '0');
  const d = String(monday.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function formatWeeklyProgress(weekly) {
  const currentWeek = getWeekKey();
  const sameWeek = !weekly?.weekKey || weekly.weekKey === currentWeek;
  const drivers = sameWeek ? Number(weekly?.drivers) || 0 : 0;
  const customers = sameWeek ? Number(weekly?.customers) || 0 : 0;
  const dGoal = Number(weekly?.driversGoal) || WEEKLY_MIN_DRIVERS;
  const cGoal = Number(weekly?.customersGoal) || WEEKLY_MIN_CUSTOMERS;
  return {
    weekKey: sameWeek ? weekly?.weekKey || currentWeek : currentWeek,
    driversLabel: `${drivers}/${dGoal}`,
    customersLabel: `${customers}/${cGoal}`,
    driversOk: drivers >= dGoal,
    customersOk: customers >= cGoal,
    drivers,
    customers,
    dGoal,
    cGoal,
  };
}
